export default "/_nuxt/80b70e201434b8207f68f5ade46c03e8.svg";